const shopName = (state = "", action) => {
    switch(action.type) {
        case 'shopName':
            return action.payload;
        default:
            return state;
    }
}

export default shopName;